import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import { EncashedLeaveProcessColumns } from "../../tableColumns/table-columns";
import { CompOffJson } from "../../DynamicFormsJson/Transaction/compOff";
import { withRouter } from "../../components/withRouter";
import { compose } from "recompose";
import { getActiveSalesTeamByUserTypeIds } from "../../Slice/salesExecutive.slice";
import { noInternetMsg, serverMsg } from "../../config/messageconstant";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class CompOffTable extends React.Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        if (navigator.onLine) {
            this.getData();
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    getData = async () => {
        const { getActiveSalesTeamByUserTypeIds, showLoador, showNotification } = this.props;

        let dataJson = {
            userTypeIds: [3, 4],
        }
        showLoador({ loador: true });
        await getActiveSalesTeamByUserTypeIds({ userTypeIdsData: dataJson }).then(({ response, success }) => {
            if (!success) {
                showNotification({
                    msg: serverMsg,
                    severity: "error",
                });
            }
        });
        showLoador({ loador: false });
    }

    rowTransfer = (rowData) => {
        this.props.navigate(CompOffJson.openFormPathStatus + "/" + rowData.id);
    }

    render() {
        const { salesTeamList } = this.props;
        return (
            <>
                <DynamicMainScreen
                    callApi={false}
                    formPath={CompOffJson.formPath}
                    screenTitle={CompOffJson.screenTitle}
                    fieldMeta={CompOffJson.fieldMeta}
                    showPdfDownload={false}
                    showExcelDownload={true}
                    changeExcelURL={CompOffJson.excelUrl}
                    showExtension={false}
                    filterDataExcel={true}
                    pdfFileName={CompOffJson.pdfFileName}
                    excelFileName={CompOffJson.excelFileName}
                    showAddButton={false}
                    tableColumnsToFilter={CompOffJson.tableColumnsToFilter}
                    tableColumns={EncashedLeaveProcessColumns}
                    tableData={salesTeamList?.salesPersonByArea}
                    getTableData={this.getData}
                    apiBaseURL={CompOffJson.apiBaseURL}
                    baseIdColumn={CompOffJson.baseIdColumn}
                    showDeleteIcon={false}
                    showViewButtonInTable={true}
                    formPathView={CompOffJson.formPathView}
                    isActiveURL={CompOffJson.isActiveURL}
                    showEditIcon={false}
                    showTransferButtonInTable={true}
                    showTransferTitle={"Comp Off Process"}
                    autoTransfer={false}
                    rowTransfer={this.rowTransfer}
                />
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesTeamList: state.salesExecutive
});
const mapDispatchToProps = {
    getActiveSalesTeamByUserTypeIds,
    showLoador,
    showNotification,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(CompOffTable);
